document.addEventListener("DOMContentLoaded", function () {
    const filterWrapper = document.querySelector(".semmel-connect--filter");
    const filterItems = filterWrapper.querySelectorAll("li");
    const eventsContainer = document.querySelector(".semmel-connect--events");
    const events = eventsContainer.querySelectorAll(".semmel-connect--event");
    const eventsPerPage = 8;
    let currentPage = 1;
    let selectedLocation = "all";

    // Buttons für Desktop
    const prevButton = document.createElement("button");
    const nextButton = document.createElement("button");
    prevButton.textContent = "⇠";
    nextButton.textContent = "⇢";
    prevButton.className = "filter-nav-button prev";
    nextButton.className = "filter-nav-button next";

    // Füge die Buttons vor und nach der Filterliste ein
    filterWrapper.parentElement.insertBefore(prevButton, filterWrapper);
    filterWrapper.parentElement.insertBefore(
        nextButton,
        filterWrapper.nextSibling,
    );

    // Horizontales Scrollen auf Mobilgeräten aktivieren
    filterWrapper.style.overflowX = "auto";
    filterWrapper.style.whiteSpace = "nowrap";

    // Event-Listener für Scroll-Buttons
    const scrollAmount = 362; // Pixel für jeden Klick
    prevButton.addEventListener("click", () => {
        filterWrapper.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    });
    nextButton.addEventListener("click", () => {
        filterWrapper.scrollBy({ left: scrollAmount, behavior: "smooth" });
    });

    // Funktion zum Anzeigen der Events
    function showEvents(page) {
        const start = (page - 1) * eventsPerPage;
        const end = start + eventsPerPage;
        let visibleCount = 0;

        events.forEach((event, index) => {
            const eventLocation = event.getAttribute("data-location");
            if (selectedLocation === "all" || eventLocation === selectedLocation) {
                if (visibleCount >= start && visibleCount < end) {
                    event.classList.remove("is-style-hidden");
                } else {
                    event.classList.add("is-style-hidden");
                }
                visibleCount++;
            } else {
                event.classList.add("is-style-hidden");
            }
        });

        // Button zum Anzeigen weiterer Termine
        const showMoreButton = document.querySelector(".show-more-button");
        if (!showMoreButton && visibleCount > end) {
            const button = document.createElement("button");
            button.textContent = "Weitere Termine anzeigen";
            button.className = "show-more-button";
            button.addEventListener("click", () => {
                events.forEach((event) => {
                    const eventLocation = event.getAttribute("data-location");
                    if (selectedLocation === "all" || eventLocation === selectedLocation) {
                        event.classList.remove("is-style-hidden");
                    }
                });
                button.remove();
            });
            eventsContainer.parentElement.insertBefore(button, eventsContainer.nextSibling);
        } else if (showMoreButton && visibleCount <= end) {
            showMoreButton.remove();
        }
    }

    // Initiale Anzeige der Events
    showEvents(currentPage);

    // Event-Listener für jedes Filter-Element
    filterItems.forEach((filterItem) => {
        filterItem.addEventListener("click", () => {
            selectedLocation = filterItem.getAttribute("data-location");

            // Entferne die aktive Klasse von allen Filter-Elementen
            filterItems.forEach((item) => item.classList.remove("active"));
            // Setze die aktive Klasse für das ausgewählte Filter-Element
            filterItem.classList.add("active");

            // Zeige die ersten 8 gefilterten Events
            currentPage = 1;
            showEvents(currentPage);
        });
    });

    // Event-Listener für jedes Event-Element
    events.forEach((event) => {
        const ticketLink = event.querySelector("a");
        if (ticketLink) {
            event.style.cursor = "pointer";
            event.addEventListener("click", () => {
                window.open(ticketLink.href, "_blank");
            });
        }
    });
});